
import { TweenMax,gsap, Expo,Power2,SteppedEase} from "gsap/all";
import anime from 'animejs/lib/anime.es.js';
 
export const animateSingleProject = (leftItemClassName: string) => {
    
  // TweenMax.staggerFrom(
  //   ".ml12 > .project_letter",
  //   1,
  //   {
  //     y: "60",
  //     opacity: 0,
  //     ease: Power2.easeOut,
  //     delay: 2,
  //   },
  //   0.2
  // );
  console.log('leftItemClassName',leftItemClassName)
			TweenMax.from(leftItemClassName, 3, {
				left: "-50%",
        width: "0",
				ease: Expo.easeInOut,
				delay: 3.4,
			});
			TweenMax.from(".single_project_header h1", 3, {
				left: "-140%",
				ease: Expo.easeInOut,
				delay: 3.4,
			});
			TweenMax.staggerFrom(
				".images > div",
				1,
				{
					y: "60",
					opacity: 0,
					ease: Power2.easeOut,
					delay: 6,
				},
				0.2
			);

			TweenMax.staggerFrom(
				".single_project_header > *",
				1,
				{
					y: "60",
					opacity: 0,
					ease: Power2.easeOut,
					delay: 5.6,
				},
				0.2
			);
      TweenMax.staggerTo(
				".single_project_header > a",
				1,
				{
					y: "60",
					opacity: 1,
					ease: Power2.easeOut,
					delay: 5.87,
				},
				0.2
			);
			// TweenMax.from(".link", 1, {
			// 	opacity: 0,
			// 	ease: SteppedEase.config(1),
			// 	repeat: -1,
			// 	repeatDelay: 0.2,
			// 	delay: 7.8,
			// });
}
 
export const bgProjectPageAnimation : () => void = () =>{
        
          gsap.to(".project_text-wrapper > div", 1, {
            x: "500",
            ease: Expo.easeInOut,
            delay: 1,
            stagger: 0.1,
          });
  
          gsap.to(".project_text-wrapper", 3, {
            y: -600,
            scale: 4.5,
            rotate: -90,
            ease: Expo.easeInOut,
            delay: 1.5,
          });
  
          gsap.to(".project_bg_text", 1, {
            opacity: 1,
            ease: Expo.easeInOut,
            delay: 3,
          });
  
          gsap.to(".project_text-wrapper > div", 4, {
            x: "-3500",
            ease: Expo.easeInOut,
            delay: 3.5,
            stagger: 0.05 
          });
  
          gsap.to(".project_text-container", 2, {
            bottom: "-100%",
            ease: Expo.easeInOut,
            delay: 6,
          });
          gsap.to(".project_bg_text", 4, {
            opacity: 0,
            ease: Expo.easeInOut, 
            delay: 4.5
          });
      //     gsap.to(".project_text-wrapper", 4, {
      //      display: "none",
      //       delay: 6,
      //     });
          gsap.to(".project_header", 4, {
            zIndex: 4,
             delay: 8,
           });
}